import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";

export const requestDeletePack = async (packId: string): Promise<void> => {
  return await instance.delete(buildUrl(ApiRoutesPacks.Packs, packId));
};
